<template>
  <div>
    <main-layout>
      <v-container>
        <div style="background-color: #eee; border-radius: 10px">
          <v-layout>
            <v-flex xs6>
              <v-img src="/static/img/assets/ticket2/call-center-rafiki.png"></v-img>
            </v-flex>
            <v-flex xs3 style="display: flex; justify-content: center; align-items: center">
              <div class="text-xs-center black--text" style="font-size: 20px">
                <div>
                  HELLO! <strong>{{ $store.state.userid }}</strong>
                </div>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      :loading="saveloading"
                      :disabled="checkinstatus"
                      @click="ticket2checkincheckout('check-in')"
                      class="ticket2profilebtn"
                      color="white"
                      large
                    >
                      <div>
                        <div>
                          <img
                            :style="checkinstatus ? 'filter: grayscale(100%);' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/login-2.png"
                          />
                        </div>
                        <div>Check-in</div>
                      </div>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      :loading="saveloading"
                      :disabled="!checkinstatus"
                      @click="ticket2checkincheckout('check-out')"
                      class="ticket2profilebtn"
                      color="white"
                      large
                    >
                      <div>
                        <div>
                          <img
                            :style="!checkinstatus ? '    filter: grayscale(100%);' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/logout-1.png"
                          />
                        </div>
                        <div>Check-out</div>
                      </div>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex xs3 class="py-4 pl-4">
              <div style="background-color: #e1e1e1; border-radius: 10px">
                <div class="pa-2">
                  <div>
                    <div style="font-weight: 500" class="text-xs-right">Work log</div>
                    <div style="height: 400px; overflow: auto" v-if="logloading">
                      <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
                    </div>
                    <div v-else style="height: 400px; overflow: auto">
                      <div v-for="(log, k) in logdata" :key="k" class="my-2">
                        <div style="font-size: 13px">
                          คุณได้ทำการ<span
                            v-if="log.actions == 'check-in'"
                            style="color: #e5917e; font-weight: bold"
                          >
                            เข้าสู่ระบบ
                          </span>
                          <span style="color: grey; font-weight: bold" v-else> ออกจากระบบ </span>
                          วันที่
                          {{ log.timestamp | DateFormat('DD/MM/YYYY เวลา HH:mmน.') }}
                        </div>
                        <v-divider></v-divider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  computed: {
    ...mapGetters(['selectedBot']),
    checkinstatus() {
      if (this.logdata && this.logdata.length && this.logdata[0].actions == 'check-in') {
        return true
      } else return false
    }
  },
  components: {
    ScaleLoader
  },
  data() {
    return {
      logloading: false,
      saveloading: false,
      logdata: []
    }
  },
  mounted() {
    this.ticket2CheckinCheckoutLog()
  },
  methods: {
    ticket2CheckinCheckoutLog() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        this.logloading = true
        api.ticket2CommonCheckinCheckoutLog(data, (err, response) => {
          if (err) {
            reject()
            return
          }

          this.logloading = false
          this.logdata = response.data
          resolve()
        })
      })
    },
    ticket2checkincheckout(actions) {
      var data = {
        adminId: this.$store.state.userid,
        pageid: this.selectedBot.pageid,
        actions // check-in หรือ check-out
      }
      this.$swal
        .fire({
          text: `คุณต้องการ ${actions} ?`,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.saveloading = true
            api.ticket2CommonCheckinCheckout(data, async (err, response) => {
              if (response.responsecode == 200) {
                await this.ticket2CheckinCheckoutLog()
                this.saveloading = false
                this.$swal.fire({
                  text: actions + ' สำเร็จ',
                  type: 'success'
                })
              }
            })
          }
        })
    }
    // ticket2checkstatus() {
    //   var data = {
    //     adminId: this.$store.state.userid,
    //   }
    //   api.ticket2checkstatus(data, (err, response) => {
    //     console.log(response)
    //   })
    // },
  }
}
</script>

<style lang="scss">
.ticket2profilebtn {
  border-radius: 15px !important;
  width: 100px !important;
  height: 94px !important;
  font-size: 14px !important;
  text-transform: none !important;

  color: grey !important;

  line-height: 21px !important;
  margin-top: 10px !important;
  //   display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/cityfresh/profile/CityFreshprofile.vue